import React from 'react';
import Clock from 'react-live-clock';
import { useNavigate } from 'react-router-dom';

import mapImage from '../images/map.png';
import resourceImage from '../images/udstyr.png';
import logoImage from '../images/fureso_logo.png';
import eventsImage from '../images/events.png';
import allocatedUnitImage from '../images/car3.svg';

import './Menu.css';

const Menu = () => {
    const navigate = useNavigate();
    return(
        <div className="menu">
             <Clock format={'HH:mm'} ticking={true} timezone={'Europe/Copenhagen'} interval={30000}/>
            <div className="menu-point-container">
                <div className="menu-point"><div onClick={() => navigate('/')}><img src={require('../images/home.png')} alt='Hjem menu'/></div></div>
                <div className="menu-point"><div onClick={() => navigate('/plan')}><img src={require('../images/plan.png')} alt='Plan menu'/></div></div>
                <div className="menu-point"><div onClick={() => navigate('/documents')}><img src={require('../images/documents.png')} alt='Arkiv menu'/></div></div>
                <div className="menu-point" onClick={() => navigate('/map')}><img src={mapImage} alt='Map menu' /></div>
                <div className="menu-point" onClick={() => navigate('/resource')}><img src={resourceImage} alt='Resource menu' /></div>
                <div className="menu-point" onClick={() => navigate('/allocatedUnit')}><img src={allocatedUnitImage} alt='AllocatedUnit menu' /></div>
                <div className="menu-point" onClick={() => navigate('/events')}><img src={eventsImage} alt='events menu' /></div>
                <img style={{position: 'absolute', bottom: 0, left: 0, opacity: 0.5 }} onClick={() => navigate('/login')} src={logoImage} alt='' />
            </div>

        </div>
    );
};

export default Menu;